export const i18n = {};
